import Calendar from "color-calendar";
import {createPopper} from '@popperjs/core';
import moment from 'moment';


const AUTH_TOKEN = $('meta[name="csrf-token"]').attr('content');
const tabContentResizeObserver = new ResizeObserver(() => {
    $(".tab-content").css('height', 'auto');
});

const sampleTimelineColor = "#C1E9FA";
const pricingTimelineColor = "#DDF566";
const rfiTimelineColor = "#F2E0FF";
const requestDeadlineColor = "#B7F8BC";
const productLaunchTimelineColor = "#FF9C3280";

const REVENUE_STEPS = [0, 100000, 500000, 1000000, 5000000, 10000000, 20000000, 50000000, 100000000, 500000000, -1];
const REVENUE_DISPLAY = ["0", "100K", "500K", "1M", "5M", "10M", "20M", "50M", "100M", "500M", "No limit"];

window.Deal = {
    init() {
        let calendar = null;

        this.initDropZone();
        this.initLightSlider();
        this.initForm();
        this.initWizard();
        this.initPopover();
        this.initFieldTooltips();
        this.initQuantityPerPeriod();
        window.SkuCards?.init($('.sku-screen'));
        this.initBenchmarkProducts();
        this.initCertificateOverlapNotice();
        this.initCalendar();
        this.validateForm();
        this.handleOnClickRemoveAttachment();
        this.changeDealStatus();
        this.handleClickEvents();
    },

    initDropZone() {
        const self = this
        // Looked up on use so the toolbar Go Live button (added by initWizard) is included too.
        const submitBtn = () => $('.submit-deal-btn')
        $(".dropzone").not(".dz-clickable").each((index, element) => {
            $(element).dropzone({
                url: "/deals/upload_deal_attachment",
                previewsContainer: $(element).siblings('.drop-zone-preview')[0],
                previewTemplate: document.querySelector('.drop-zone-custom').innerHTML,
                uploadMultiple: false,
                maxFiles: 20,
                maxFileSize: 10,
                thumbnailWidth: 75,
                thumbnailHeight: 75,
                acceptedFiles: "image/*,video/*,application/*",
                init: function () {
                    this.on("error", function (file) {
                        this.removeFile(file);
                        $('.dropzone').after(
                            '<div class="alert alert-danger alert-dismissable" id="rr-success-alert">' +
                            '<button type="button" class="close" ' +
                            'data-dismiss="alert" aria-hidden="true">' +
                            '&times;' +
                            '</button>' +
                            'This file format is not supported' +
                            '</div>'
                        );
                        $("#rr-success-alert").fadeTo(5000, 500).slideUp(500, function () {
                            $("#rr-success-alert").slideUp(500);
                        });
                        setTimeout(function () {
                            $("#rr-success-alert").remove();
                        }, 6000);
                    });
                },
                params: {
                    'authenticity_token': AUTH_TOKEN
                },
                success: (file, response) => {
                    if (response.err_msg === '' || response.err_msg === undefined) {
                        const dealAttachmentsElement = $("#deal-attachments");
                        $(file.previewElement).find('.dz-remove').attr('data-attachment-id', response.id);
                        dealAttachmentsElement.append(`<input type='hidden' value='${response.id}' name='deal[deal_attachment_ids][]'>`);
                        self.handleOnClickRemoveAttachment();
                    } else {
                        alert(response.err_msg);
                        file.previewElement.remove();
                    }
                    submitBtn().removeAttr('disabled');
                },
                sending: () => {
                    submitBtn().attr('disabled', 'disabled')
                }
            });
        });
    },

    handleRemoveAttachment(e) {
        const attachmentId = e.currentTarget.dataset.attachmentId;
        $(`#deal-attachments :input[value="${attachmentId}"]`).remove();
        $(e.target).parents('.dz-preview').remove();
    },

    handleOnClickRemoveAttachment() {
        $(".remove-attachment").on('click', this.handleRemoveAttachment.bind(this))
    },

    initForm() {
        $('.occasion-select2').each(function () {
            $(this).select2({
                tags: true,
                allowClear: true,
                width: '100%',
                placeholder: $(this).data('placeholder') || ''
            });
        });
    },

    // Label tooltips rendered by DealFormHelper#field_tooltip (specs/017-deal-form-new-fields FR-026).
    initFieldTooltips() {
        $('.deal_form .deal-field-tooltip').popover({
            placement: 'top',
            trigger: 'hover focus',
            html: true,
            container: 'body'
        });
    },

    // Qty per Period = Annual Unit Quantity / periods in the chosen Frequency (FR-017, FR-018).
    initQuantityPerPeriod() {
        const output = $('#deal_quantity_per_period');
        if (!output.length) return;

        const labels = output.data('labels');
        const periods = output.data('periods');
        const update = () => {
            const quantity = parseFloat($('#deal_quantity').val());
            const frequency = $('#deal_frequency').val();
            $('#deal_quantity_per_period_label').text(labels[frequency] || labels.blank);

            if (!frequency || !(quantity > 0)) {
                output.val('');
            } else {
                // Whole units only, rounded up (matches Deal#quantity_per_period).
                const value = Math.ceil(quantity / periods[frequency]);
                output.val(value.toLocaleString());
            }
            if (frequency) $('#legacy_frequency_text').hide();
        };

        $('#deal_quantity').on('input change', update);
        $('#deal_frequency').on('change', update);
    },

    // Growable Benchmark Products list with a link/pencil prefix icon (FR-002, FR-003).
    initBenchmarkProducts() {
        const list = $('#benchmark-products-list');
        if (!list.length) return;

        const addLink = $('#add-benchmark-product');
        const limit = parseInt(addLink.data('limit'), 10) || 20;
        const setIcon = (input) => {
            const icon = /^http/i.test($(input).val().trim()) ? '🔗' : '✎';
            $(input).closest('.benchmark-product-row').find('.benchmark-icon').text(icon);
        };
        const toggleAddLink = () => addLink.toggle(list.find('.benchmark-product-row').length < limit);

        list.on('input', '.benchmark-product-input', function () {
            setIcon(this);
        });
        list.on('click', '.remove-benchmark-product', function () {
            const rows = list.find('.benchmark-product-row');
            const row = $(this).closest('.benchmark-product-row');
            if (rows.length > 1) {
                row.remove();
            } else {
                row.find('.benchmark-product-input').val('');
                setIcon(row.find('.benchmark-product-input'));
            }
            toggleAddLink();
        });
        addLink.on('click', function (e) {
            e.preventDefault();
            const row = list.find('.benchmark-product-row').first().clone();
            row.find('.benchmark-product-input').val('');
            row.find('.benchmark-icon').text('✎');
            list.append(row);
            row.find('.benchmark-product-input').trigger('focus');
            toggleAddLink();
        });
        toggleAddLink();
    },

    // A certification chosen as both mandatory and desired is saved as mandatory only (research D4).
    initCertificateOverlapNotice() {
        const mandatory = $('#deal_certificate_ids');
        const desired = $('#deal_optional_certificate_ids');
        if (!mandatory.length || !desired.length) return;

        const check = () => {
            const chosen = (mandatory.val() || []).map((v) => v.toLowerCase());
            const overlap = (desired.val() || []).some((v) => chosen.includes(v.toLowerCase()));
            $('#certificate-overlap-notice').toggle(overlap);
        };
        mandatory.on('change', check);
        desired.on('change', check);
        check();
    },

    initLightSlider() {
        $("#light-slider").lightSlider({
            gallery: true,
            item: 1,
            thumbItem: 5,
            slideMargin: 0,
            speed: 500,
            pause: 5000,
            pauseOnHover: true,
            auto: true,
            loop: true,
            prevHtml: '&lt;',
            nextHtml: '&gt;',
            onSliderLoad: function () {
                $('#light-slider').removeClass('cS-hidden');
            }
        });
    },

    initCalendar() {
        Deal.calendar = new Calendar({
            container: "#color-calendar",
            calendarSize: "large",
            eventBulletMode: "multiple",
            initialSelectedDate: null,
            onSelectedDateChange: (currentDate, events) => {
                if (currentDate != null) {
                    Deal.populateEventDetails(currentDate, events);
                }
            },
            onSelectedDateClick: (currentDate, events) => {
                if (currentDate != null) {
                    Deal.populateEventDetails(currentDate, events);
                }
            },
            primaryColor: "#31B4ED",
            headerColor: "#154254",
            weekdaysColor: "#154254",
            dropShadow: "none",
            border: false,
            borderRadius: "0.5rem",
            fontFamilyBody: "Montserrat",
            fontFamilyHeader: "Rubik",
            fontFamilyWeekdays: "Montserrat",
            fontFamilyBase: "Montserrat"
        });

        const dealSampleMinDeadline = $("#deal_sample_min_deadline").val();
        const dealSampleMaxDeadline = $("#deal_sample_max_deadline").val();

        const dealPricingMinDeadline = $("#deal_pricing_min_deadline").val();
        const dealPricingMaxDeadline = $("#deal_pricing_max_deadline").val();

        const dealRfiMinDeadline = $("#deal_rfi_min_deadline").val();
        const dealRfiMaxDeadline = $("#deal_rfi_max_deadline").val();

        const dealRequestDeadline = $("#deal_stage_deadline").val();

        const dealProductLaunchMinDeadline = $("#deal_launch_min_deadline").val();
        const dealProductLaunchMaxDeadline = $("#deal_launch_max_deadline").val();

        Deal.calendar.setEventsData([
            {
                title: "Sample timeframe",
                start: new Date(dealSampleMinDeadline),
                end: new Date(dealSampleMaxDeadline),
                color: sampleTimelineColor,
                type: "sample",
                mode: "range"
            },
            // {
            //     title: "Pricing timeframe",
            //     start: new Date(dealPricingMinDeadline),
            //     end: new Date(dealPricingMaxDeadline),
            //     color: pricingTimelineColor,
            //     type: "pricing",
            //     mode: "range"
            // },
            // {
            //     title: "RFI timeframe",
            //     start: new Date(dealRfiMinDeadline),
            //     end: new Date(dealRfiMaxDeadline),
            //     color: rfiTimelineColor,
            //     type: "rfi",
            //     mode: "range"
            // },
            {
                title: "Request deadline",
                start: new Date(dealRequestDeadline),
                end: new Date(dealRequestDeadline),
                color: requestDeadlineColor,
                type: "request_deadline",
                mode: "single"
            },
            {
                title: "Product launch timeframe",
                start: new Date(dealProductLaunchMinDeadline),
                end: new Date(dealProductLaunchMaxDeadline),
                color: productLaunchTimelineColor,
                type: "product_launch",
                mode: "range"
            },
        ])

        // Buttons inside the calendar can be type submit.
        // This was causing an issue where the form was submitted at the wrong time.
        // This is a workaround to prevent that.
        const calendarContainer = $("#color-calendar");
        calendarContainer.find("button").attr("type", "button");
        calendarContainer.on("click", "button, .cc__header button, .cc__arrow, .cc__btn", function (e) {
            e.preventDefault();
            e.stopPropagation();
        });
    },

    initPopover() {
        const POPOVER_TEMPLATE = '<div class="popover company-private-popover"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>';
        const POPOVERS = [
            {
                selector: '#public_deal',
                content: "All Kwayga members can see it was you who posted this request.",
                trigger: "hover"
            },
            {selector: '#private_deal', content: "No one can see who posted this request.", trigger: "hover"},
            {
                selector: '#connected_deal',
                content: " Only your Kwayga Connections can see it was you who posted this request.",
                trigger: "hover"
            },
            {
                selector: '#deal_stage_deadline',
                title: "Request Deadline",
                content: "Specify a date time by which this request will be closed.",
                trigger: "focus"
            },
        ];
        POPOVERS.forEach(({selector, ...opts}) => {
            $(selector).popover({placement: 'top', template: POPOVER_TEMPLATE, ...opts});
        });
    },

    // Stops (REVENUE_STEPS) are unchanged; only the Min/Max labels and styling are new (research D13).
    initRevenueSlider() {
        $(function () {
            const slider = $("#revenue-range-slider");
            if (!slider.length) return;

            const currency = slider.data('currency') || '';
            const noLimit = slider.data('no-limit') || REVENUE_DISPLAY[REVENUE_DISPLAY.length - 1];
            const label = (index) => {
                const display = window.Deal.parseRevenueSliderDisplayValue(index);
                return index === REVENUE_STEPS.length - 1 ? noLimit : `${currency}${display}`;
            };
            const render = (values) => {
                $("#turnover_min_label").text(label(values[0]));
                $("#turnover_max_label").text(label(values[1]));
                $("#price").val(`${label(values[0])} - ${label(values[1])}`);
            };

            slider.slider({
                range: true,
                min: 0,
                max: REVENUE_STEPS.length - 1,
                values: [0, REVENUE_STEPS.length - 1],
                slide: function (event, ui) {
                    $("#deal_supplier_turnover_min").val(window.Deal.parseRevenueSliderValue(ui.values[0]));
                    $("#deal_supplier_turnover_max").val(window.Deal.parseRevenueSliderValue(ui.values[1]));
                    render(ui.values);
                }
            });

            const from = window.Deal.parseRevenueValueToSliderValue($("#deal_supplier_turnover_min").val());
            const toValue = parseInt($("#deal_supplier_turnover_max").val(), 10);
            const to = Number.isNaN(toValue) ? REVENUE_STEPS.length - 1 : window.Deal.parseRevenueValueToSliderValue(toValue);

            slider.slider("values", [from, to]);
            render([from, to]);
        });
    },

    initWizard() {
        // On the Preview step the toolbar shows Go Live in place of the (disabled) Next button. It shares the
        // submit-deal-btn class, so changeDealStatus gives it the same behaviour as the Go Live button on the page.
        const goLiveLabel = $('.submit-deal-btn').first().text().trim() || 'Go Live';
        const goLiveButton = $('<button type="button">')
            .addClass('btn btn-picton-blue text-white submit-deal-btn sw-btn-go-live')
            .css('display', 'none')
            .text(goLiveLabel);

        $('#smartwizard').smartWizard({
            selected: 0,
            theme: "square",
            justified: true,
            autoAdjustHeight: true,
            enableURLhash: false,
            transition: {
                animation: 'slide-horizontal',
                speed: '400',
                easing: ''
            },
            keyboard: {
                keyNavigation: false
            },
            toolbar: {
                position: 'bottom',
                showNextButton: true,
                showPreviousButton: true,
                extraHtml: goLiveButton.prop('outerHTML')
            },
            anchor: {
                enableNavigation: false,
                enableNavigationAlways: false,
                enableDoneState: true,
                markPreviousStepsAsDone: true,
                unDoneOnBackNavigation: true
            },
            lang: {
                next: 'Next →',
                previous: '← Previous'
            }
        });

        $("#smartwizard").on("showStep", function (e, anchorObject, stepNumber, stepDirection, stepPosition) {
            const onPreview = stepPosition === 'last';
            $('#smartwizard .sw-btn-next').toggle(!onPreview);
            $('#smartwizard .sw-btn-go-live').toggle(onPreview);

            $('html, body').animate({
                scrollTop: $('#smartwizard').offset().top - 200
            }, 'slow');
        })

        var skipLeaveStep = false;
        $("#smartwizard").on("leaveStep", function (e, anchorObject, currentStepIndex, nextStepIndex, stepDirection) {
            if (skipLeaveStep) {
                skipLeaveStep = false;
                return true;
            }

            if (stepDirection != "forward") {
                return true;
            }

            let valid = [];

            var valuesToSubmit = $('.deal_form').serialize();
            let type = 'POST';
            let url = '/deals';
            let redirectPath = '/deals/new';
            let dealUuid = $('#deal_uuid').val();
            if (dealUuid != null && dealUuid != '') {
                type = 'PUT';
                url = '/deals/' + dealUuid;
                redirectPath = `/deals/${dealUuid}/edit`;
            }

            function saveAndAdvance(onSuccess) {
                $.ajax({
                    type: type,
                    url: url,
                    data: valuesToSubmit,
                    dataType: 'json',
                    success: function (data) {
                        if (data.uuid != null) {
                            $('#deal_uuid').val(data.uuid);
                        }
                        window.SkuCards?.applySavedIds(data.skus);
                        skipLeaveStep = true;
                        if (onSuccess) onSuccess(data);
                        $('#smartwizard').smartWizard('next');
                    },
                    error: function () {
                        window.location.href = redirectPath;
                    }
                });
            }

            if (currentStepIndex === 0) {
                valid.push($("[name='deal[team_id]']").valid());
                valid.push($("input[name='deal[name]']").valid());
                const hiddenField = $("#hidden-deal-field");
                if (hiddenField.length) {
                    valid.push(hiddenField.valid());
                }
                valid.push($("#deal_deal_buyer_geography_ids").valid());

                if (!valid.every(Boolean)) {
                    return false
                } else {
                    saveAndAdvance();
                    return false;
                }
            } else if (currentStepIndex === 1 && $('.sku-screen').length) {
                // ai_deal: the SKU screen replaces classic sizing (specs/018-ai-deal-form-assistant FR-044)
                valid.push(window.SkuCards.validate());
                window.Deal.initRevenueSlider();

                if (!valid.every(Boolean)) {
                    return false
                } else {
                    saveAndAdvance();
                    return false;
                }
            } else if (currentStepIndex === 1) {
                valid.push($("#deal_quantity").valid());
                valid.push($("#deal_storage_type").valid());
                valid.push($("#deal_labelling_option_ids").valid());
                valid.push($("#deal_budget").valid());
                window.Deal.initRevenueSlider();

                if (!valid.every(Boolean)) {
                    return false
                } else {
                    saveAndAdvance();
                    return false;
                }
            } else if (currentStepIndex === 2) {
                valid.push($("#deal_geography_ids").valid());
                valid.push($("#deal_excluded_geography_ids").valid());

                if (!valid.every(Boolean)) {
                    return false
                } else {
                    saveAndAdvance();
                    return false;
                }
            } else if (currentStepIndex === 3) {
                valid.push($("#deal_stage_deadline").valid());

                if (!valid.every(Boolean)) {
                    return false
                } else {
                    saveAndAdvance((data) => window.Deal.initPreview(data));
                    return false;
                }
            }
            return !valid.includes(false);
        });

        if (document.querySelector('#step-0') != null) {
            ['#step-0', '#step-1', '#step-2', '#step-3', '.tab-content'].forEach(sel => {
                const el = document.querySelector(sel);
                if (el) tabContentResizeObserver.observe(el);
            });
        }
    },
    // Writes a Preview value, falling back to "Not specified" for blanks (FR-030).
    setPreviewValue(selector, value) {
        const emptyText = $('#deal-preview').data('empty-text') || 'Not specified';
        const blank = value === null || value === undefined || String(value).trim() === '' ||
            String(value).trim().toLowerCase() === 'not specified' || (Array.isArray(value) && value.length === 0);
        $(selector).text(blank ? emptyText : value);
    },

    setPreviewList(selector, items, render) {
        const list = $(selector);
        list.empty();
        const values = (items || []).filter((item) => item !== null && item !== undefined && String(item.text ?? item).trim() !== '');
        if (!values.length) {
            list.append($('<li>').addClass('list-unstyled').text($('#deal-preview').data('empty-text') || 'Not specified'));
            return;
        }
        values.forEach((item) => list.append(render(item)));
    },

    initPreview(data) {
        const self = window.Deal;
        $('#d_name').text(data.name);
        $('#d_description').html(data.description);
        self.initSkuTablePreview(data);
        self.setPreviewValue('#d_buyer_location', data.buyer_location);
        self.setPreviewValue('#d_occasion', data.occasion);
        self.setPreviewList('#d_benchmark_products', data.benchmark_products, (product) => {
            const item = $('<li>');
            if (product.url) {
                item.append($('<a>').attr({href: product.url, target: '_blank', rel: 'noopener nofollow'}).text(product.text));
            } else {
                item.text(product.text);
            }
            return item;
        });

        self.setPreviewValue('#d_annual_quantity', data.annual_quantity);
        self.setPreviewValue('#d_frequency', data.frequency);
        $('#d_quantity_per_period_label').text(data.quantity_per_period_label);
        self.setPreviewValue('#d_quantity_per_period', data.quantity_per_period);
        self.setPreviewValue('#d_storage_type', data.storage_type);
        self.setPreviewValue('#d_packaging_requirements', data.packaging_requirements);
        self.setPreviewValue('#d_packaging_type', data.packaging_type);
        self.setPreviewValue('#d_country_of_origin', data.country_of_origin);
        self.setPreviewValue('#d_estimated_cost_price', data.estimated_cost_price);

        self.setPreviewValue('#d_location', data.location);
        self.setPreviewValue('#d_excluded_location', data.excluded_location);
        self.setPreviewValue('#d_trading_history', data.trading_history);
        self.setPreviewValue('#d_turnover', data.turnover);
        self.setPreviewValue('#d_split_preference', data.split_preference);
        // The confidential supplier lists are never in the JSON payload; read them from the form (research D15).
        self.setPreviewValue('#d_incumbent_supplier', $('#deal_incumbent_supplier').val());
        self.setPreviewValue('#d_suppliers_in_conversation', $('#deal_suppliers_in_conversation').val());
        self.setPreviewValue('#d_incoterm', data.incoterm);

        let stage_deadline = document.getElementsByName('deal[stage_deadline]')[0].value;
        $('#d_deadline').text(moment(stage_deadline).format("DD.MM.YYYY"));

        let sample_min_timeframe = document.getElementsByName('deal[sample_min_deadline]')[0].value;
        let sample_max_timeframe = document.getElementsByName('deal[sample_max_deadline]')[0].value;
        let sampleMoment = moment(sample_min_timeframe);
        let sampleMaxMoment = moment(sample_max_timeframe);
        $('#d_sample_timeframe').text(sampleMoment.isValid() && sampleMaxMoment.isValid() ? `${sampleMoment.format("DD.MM.YYYY")} - ${sampleMaxMoment.format("DD.MM.YYYY")}` : '');

        let pricing_min_timeframe = document.getElementsByName('deal[pricing_min_deadline]')[0].value;
        let pricing_max_timeframe = document.getElementsByName('deal[pricing_max_deadline]')[0].value;
        let pricingMoment = moment(pricing_min_timeframe);
        let pricingMaxMoment = moment(pricing_max_timeframe);
        $('#d_pricing_timeframe').text(pricingMoment.isValid() && pricingMaxMoment.isValid() ? `${pricingMoment.format("DD.MM.YYYY")} - ${pricingMaxMoment.format("DD.MM.YYYY")}` : '');

        let rfi_min_timeframe = document.getElementsByName('deal[rfi_min_deadline]')[0].value;
        let rfi_max_timeframe = document.getElementsByName('deal[rfi_max_deadline]')[0].value;
        let rfiMoment = moment(rfi_min_timeframe);
        let rfiMaxMoment = moment(rfi_max_timeframe);
        $('#d_rfi_timeframe').text(rfiMoment.isValid() && rfiMaxMoment.isValid() ? `${rfiMoment.format("DD.MM.YYYY")} - ${rfiMaxMoment.format("DD.MM.YYYY")}` : '');

        let launch_min_timeframe = document.getElementsByName('deal[launch_min_deadline]')[0].value;
        let launch_max_timeframe = document.getElementsByName('deal[launch_max_deadline]')[0].value;
        let launchMoment = moment(launch_min_timeframe);
        let launchMaxMoment = moment(launch_max_timeframe);
        $('#d_product_launch_timeframe').text(launchMoment.isValid() && launchMaxMoment.isValid() ? `${launchMoment.format("DD.MM.YYYY")} - ${launchMaxMoment.format("DD.MM.YYYY")}` : '');

        self.setPreviewValue('#d_product_levels', (data.product_levels || []).join(', '));
        self.setPreviewValue('#d_labelling_options', (data.labelling_options || []).join(', '));

        const listItem = (text) => $('<li>').text(text.trim());
        self.setPreviewList('#d_certificate', (data.certificates || '').split(','), listItem);
        self.setPreviewList('#d_optional_certificate', (data.optional_certificates || '').split(','), listItem);

        let category = document.getElementsByName('deal[deal_category_id]')[0];
        self.setPreviewValue('#d_category', category.value ? category.options[category.selectedIndex].text : '');

        let attachments = ""
        data.non_images.forEach(function (value, index) {
            attachments +=
                `<div class="row mb-1">
        <div class="col-auto align-self-center">
          <i class="fas fa-file">
          </i></div>
        <div class="col align-self-center">
          <p class="my-auto">
            ${value.name}
          </p>
        </div>
        <div class="col-4 text-end p-0">
          <a class="btn btn-primary btn-sm mx-3" target="_blank" href="${value.url}">
            <i class="fas fa-cloud-download-alt mr-2 text-white" style="margin-right: 8px;">
            </i>View
          </a></div>
      </div>`
        });
        $('#d_attachment').empty()
        $('#d_attachment').append(attachments)

        let images = ""
        data.images.forEach(function (value, index) {
            images +=
                `<div class="col-sm-6 col-md-4 col-lg-3 item">
        <a href="${value}" target="_blank"><img class="img-fluid" src="${value}" /></a>
      </div>`
        });
        $('#d_images').empty()
        $('#d_images').append(images)

        self.setPreviewValue('#d_message_template', data.message_template_name);
    },
    changeDealStatus() {
        $('.submit-deal-btn').click(function () {
            const dealUuid = $('#deal_uuid').val();
            $.ajax({
                type: "PUT",
                url: `/deals/${dealUuid}/live`,
                data: {state: true},
            });
        })
    },
    parseRevenueSliderDisplayValue(index) {
        return REVENUE_DISPLAY[index] ?? "Not Specified";
    },

    parseRevenueSliderValue(index) {
        return REVENUE_STEPS[index] ?? 0;
    },

    parseRevenueValueToSliderValue(value) {
        const idx = REVENUE_STEPS.indexOf(parseInt(value));
        return idx >= 0 ? idx : 0;
    },

    // ai_deal Preview: the SKU table replaces the sizing rows (specs/018-ai-deal-form-assistant FR-047).
    initSkuTablePreview(data) {
        const body = $('#d_sku_table tbody');
        if (!body.length || data.form_type !== 'ai_deal') return;

        const empty = $('#deal-preview').data('empty-text');
        const cell = (value) => $('<td>').text(value === null || value === undefined || value === '' ? empty : value);
        body.empty();
        (data.skus || []).forEach((sku, index) => {
            const row = $('<tr>');
            row.append(cell(index + 1), cell(sku.product_details), cell(sku.annual_quantity), cell(sku.unit_type), cell(sku.frequency),
                cell(sku.quantity_per_period && sku.quantity_per_period.value),
                cell((sku.labelling || []).join(', ')), cell((sku.product_levels || []).join(', ')),
                cell(sku.estimated_cost_price));
            body.append(row);
        });
    },

    validateForm() {
        // A country can't be both a supplier location and excluded (FR-016).
        $.validator.addMethod("noGeographyOverlap", function (value, element) {
            const supplier = $("#deal_geography_ids").val() || [];
            const excluded = $(element).val() || [];
            return !excluded.some((id) => supplier.includes(id));
        }, function (params, element) {
            return $(element).data('msg-no-geography-overlap');
        });

        $.validator.addMethod("dealStageDeadline", function (value, element) {
            let deadline = new Date($('#deal_stage_deadline').val());
            let today = new Date();
            today.setHours(0, 0, 0, 0);
            deadline.setHours(0, 0, 0, 0);

            let businessDays = 0;
            let current = new Date(today);

            while (current < deadline) {
                current.setDate(current.getDate() + 1);
                const day = current.getDay();
                if (day !== 0 && day !== 6) {
                    businessDays++;
                }
            }

            return businessDays >= 2;
        }, "You must select a Deal Stage Deadline more than 2 business days from now");

        $(".deal_form").validate({
            onkeyup: false,
            onblur: true,
            ignore: [],
            rules: {
                "deal[team_id]": {
                    required: true
                },
                "deal[name]": {
                    required: true,
                    maxlength: 100
                },
                "deal[deal_buyer_geography_ids][]": {
                    required: true
                },
                "deal[deal_stage]": {
                    required: true
                },
                "deal[stage_deadline]": {
                    dealStageDeadline: true,
                    required: true
                },
                "deal[description]": {
                    required: true
                },
                "deal[quantity]": {
                    required: true,
                    min: 1
                },
                "deal[storage_type]": {
                    required: true
                },
                "deal[labelling_option_ids][]": {
                    required: true
                },
                "deal[budget]": {
                    min: 0
                },
                "deal[geography_ids][]": {
                    required: true
                },
                "deal[excluded_geography_ids][]": {
                    noGeographyOverlap: true
                }
            },
            messages: {},
            errorPlacement: function (error, element) {
                if ((element.hasClass('multi-select2') || element.hasClass('multi-select2-certificates') || element.hasClass('country-select2')) && element.next('.select2-container').length) {
                    error.insertAfter(element.next('.select2-container'));
                } else {
                    error.insertAfter(element)
                }
            }
        });
    },

    handleClickEvents() {
        $("#close-event-details-btn").on('click', function () {
            Deal.calendar.setSelectedDate(null);
            Deal.destroyPopperInstance();
        });

        $("#close-create-event-details-btn").on('click', function () {
            Deal.calendar.setSelectedDate(null);
            Deal.destroyPopperInstance();
        });

        $("#add-sample-timeline-btn").on('click', function () {
            Deal.populateCreateEvent('sample', this);
        });

        $("#add-pricing-timeline-btn").on('click', function () {
            Deal.populateCreateEvent('pricing', this);
        });

        $("#add-rfi-timeline-btn").on('click', function () {
            Deal.populateCreateEvent('rfi', this);
        });

        $("#add-request-deadline-btn").on('click', function () {
            Deal.populateCreateEvent('request_deadline', this);
        });

        $("#add-product-launch-timeline-btn").on('click', function () {
            Deal.populateCreateEvent('product_launch', this);
        });

        const CLEAR_TIMELINE_CONFIG = [
            {
                btn: 'clear-sample-timeline-btn',
                fields: ['deal_sample_min_deadline', 'deal_sample_max_deadline'],
                type: 'sample',
                show: 'show-sample-timeline',
                add: 'add-sample-timeline-btn'
            },
            {
                btn: 'clear-pricing-timeline-btn',
                fields: ['deal_pricing_min_deadline', 'deal_pricing_max_deadline'],
                type: 'pricing',
                show: 'show-pricing-timeline',
                add: 'add-pricing-timeline-btn'
            },
            {
                btn: 'clear-rfi-timeline-btn',
                fields: ['deal_rfi_min_deadline', 'deal_rfi_max_deadline'],
                type: 'rfi',
                show: 'show-rfi-timeline',
                add: 'add-rfi-timeline-btn'
            },
            {
                btn: 'clear-request-deadline-btn',
                fields: ['deal_stage_deadline'],
                type: 'request_deadline',
                show: 'show-request-deadline',
                add: 'add-request-deadline-btn'
            },
            {
                btn: 'clear-product-launch-timeline-btn',
                fields: ['deal_launch_min_deadline', 'deal_launch_max_deadline'],
                type: 'product_launch',
                show: 'show-product-launch-timeline',
                add: 'add-product-launch-timeline-btn'
            },
        ];
        CLEAR_TIMELINE_CONFIG.forEach(({btn, fields, type, show, add}) => {
            $(`#${btn}`).on('click', function () {
                fields.forEach(f => $(`#${f}`).val(null));
                Deal.calendar.setEventsData(Deal.calendar.getEventsData().filter(e => e.type !== type));
                $(`#${show}`).hide();
                $(`#${add}`).show();
            });
        });

        function bindTimelineLabelUpdate(minId, maxId, labelId) {
            const update = () => {
                const min = moment($(`#${minId}`).val()).format('DD.MM.YYYY');
                const max = maxId ? moment($(`#${maxId}`).val()).format('DD.MM.YYYY') : null;
                $(`#${labelId}`).text(max ? `${min} - ${max}` : min);
            };
            $(`#${minId}`).on('change', update);
            if (maxId) $(`#${maxId}`).on('change', update);
        }

        bindTimelineLabelUpdate('deal_sample_min_deadline', 'deal_sample_max_deadline', 'deal-sample-timeline-label');
        bindTimelineLabelUpdate('deal_pricing_min_deadline', 'deal_pricing_max_deadline', 'deal-pricing-timeline-label');
        bindTimelineLabelUpdate('deal_rfi_min_deadline', 'deal_rfi_max_deadline', 'deal-rfi-timeline-label');
        bindTimelineLabelUpdate('deal_stage_deadline', null, 'deal-request-deadline-label');
        bindTimelineLabelUpdate('deal_launch_min_deadline', 'deal_launch_max_deadline', 'deal-product-launch-timeline-label');
    },

    populateEventDetails(currentDate, events) {
        const formattedDate = moment(currentDate).format("MMMM DD, YYYY");
        $("#event-selected-date").text(formattedDate);

        const eventList = $("#event-list");
        eventList.empty();

        if (events && events.length > 0) {
            events.forEach(function (event) {
                const eventStart = moment(event.start).format("DD.MM.YYYY")
                const eventEnd = moment(event.end).format("DD.MM.YYYY")
                const eventHtml = `
                    <div style="display: flex; flex-direction: column; justify-content: space-between;">
                        <h6 class="mb-0">${event.title}</h6>
                        <div style="display: flex; flex-direction: row; justify-content: space-between; gap: 0.5rem;">
                            <div class="mb-2 p-2" style="display: flex; flex: 1; flex-direction: column; border-radius: 0.625rem; background-color: ${event.color};">
                                 <p class="bold font-size-xxs mb-0">From</p>
                                 <p>${eventStart}</p>
                            </div>
                            ${event.mode === 'range' ? `<div class="mb-2 p-2" style="display: flex; flex: 1; flex-direction: column; border-radius: 0.625rem; background-color: ${event.color};">
                                 <p class="bold font-size-xxs mb-0">To</p>
                                 <p>${eventEnd}</p>
                            </div>` : ''}
                        </div>
                    </div>
                `;
                eventList.append(eventHtml);
            });
        } else {
            eventList.append('<p class="text-muted">No events for this date</p>');
        }

        const selectedDateCell = document.querySelector(`.calendar__day[aria-selected=true]`);
        if (selectedDateCell) {
            Deal.destroyPopperInstance();

            Deal.popperInstance = createPopper(selectedDateCell, document.getElementById('event-details-card'), {
                placement: 'left',
                modifiers: [
                    {name: 'offset', options: {offset: [0, 8]}},
                    {name: 'preventOverflow', options: {boundary: 'viewport'}},
                    {name: 'flip', options: {behavior: ['right', 'bottom', 'top']}}
                ]
            });

            $("#event-details-card").show();
            Deal.popperInstance.update();
        } else {
            console.warn("Selected date cell not found; fallback to absolute positioning.");
            $("#event-details-card").show();
        }
    },

    populateCreateEvent(eventType, element) {
        Deal.destroyPopperInstance();

        const title = $("#create-event-title");
        const createButton = $("#create-event-btn");
        const startDateInput = $("#event-start-date");
        const endDateInput = $("#event-end-date");

        const setDatepickerColor = (color) => {
            document.getElementById("event-datepicker-start").style.backgroundColor = color;
            document.getElementById("event-datepicker-end").style.backgroundColor = color;
        };

        const setDatePickerMode = (mode) => {
            const startElement = document.getElementById("event-datepicker-start");
            startElement.classList.toggle("flex-grow-1", mode === "range");

            const endElement = document.getElementById("event-datepicker-end");
            endElement.classList.toggle("is-hidden", mode === "single");
            endElement.classList.toggle("flex-grow-1", mode === "range");
        }

        const readDateRange = (mode) => {
            const startDateString = startDateInput.val();
            const start = moment(startDateString, "YYYY-MM-DD", true).toDate();
            const end = mode === "single" ? start : moment(endDateInput.val(), "YYYY-MM-DD", true).toDate();
            return {start, end};
        };

        const parsePickerDateString = (dateString) => {
            return moment(dateString, "YYYY-MM-DD", true);
        }

        const isWeekend = (momentDate) => {
            const day = momentDate.day();
            return day === 0 || day === 6;
        };

        const nextWeekday = (momentDate) => {
            const day = momentDate.day();
            if (day === 6) return momentDate.clone().add(2, 'days');
            if (day === 0) return momentDate.clone().add(1, 'day');
            return momentDate;
        };

        // Earliest selectable date for the current event type (null = today, the datepicker default).
        let minAllowedDate = null;
        const minDateMessage = () => `Please select a date on or after ${minAllowedDate.format("DD.MM.YYYY")}.`;

        const validateCreateEventDates = (mode) => {
            const error = $("#create-event-date-range-error");

            if (mode === "single") {
                const dateM = parsePickerDateString(startDateInput.val());
                if (!dateM.isValid()) {
                    error.text("Please select a valid date.").show();
                    createButton.prop("disabled", true);
                    startDateInput.addClass("is-invalid");
                    return false;
                }

                if (isWeekend(dateM)) {
                    error.text('Please select a weekday for all dates.').show();
                    createButton.prop("disabled", true);
                    startDateInput.addClass("is-invalid");
                    return false;
                }

                if (minAllowedDate && dateM.isBefore(minAllowedDate, "day")) {
                    error.text(minDateMessage()).show();
                    createButton.prop("disabled", true);
                    startDateInput.addClass("is-invalid");
                    return false;
                }

                error.hide().text("");
                createButton.prop("disabled", false);
                startDateInput.removeClass("is-invalid");
                return true;
            }

            const startM = parsePickerDateString(startDateInput.val());
            const endM = parsePickerDateString(endDateInput.val());

            if (!startM.isValid() || !endM.isValid()) {
                error.text("Please select valid dates.").show();
                createButton.prop("disabled", true);
                startDateInput.toggleClass("is-invalid", !startM.isValid());
                endDateInput.toggleClass("is-invalid", !endM.isValid());
                return false;
            }

            if (startM.isAfter(endM, "day")) {
                error.text('"From" date must be before (or the same as) the "To" date.').show();
                createButton.prop("disabled", true);
                startDateInput.addClass("is-invalid");
                endDateInput.addClass("is-invalid");
                return false;
            }

            if (isWeekend(startM) || isWeekend(endM)) {
                error.text('Please select a weekday for all dates.').show();
                createButton.prop("disabled", true);
                startDateInput.addClass("is-invalid");
                endDateInput.addClass("is-invalid");
                return false;
            }

            if (minAllowedDate && (startM.isBefore(minAllowedDate, "day") || endM.isBefore(minAllowedDate, "day"))) {
                error.text(minDateMessage()).show();
                createButton.prop("disabled", true);
                startDateInput.toggleClass("is-invalid", startM.isBefore(minAllowedDate, "day"));
                endDateInput.toggleClass("is-invalid", endM.isBefore(minAllowedDate, "day"));
                return false;
            }

            error.hide().text("");
            createButton.prop("disabled", false);
            startDateInput.removeClass("is-invalid");
            endDateInput.removeClass("is-invalid");
            return true;
        };

        // Timeframes that can't start sooner than 2 weeks from today; default to the Monday-Friday of that week.
        const twoWeeksOutRange = {
            minDate: () => nextWeekday(moment().add(2, 'weeks')),
            defaultRange: () => {
                const start = moment().add(2, 'weeks');
                if (start.day() !== 1) start.add((8 - start.day()) % 7, 'days'); // next Monday on/after
                return {start, end: start.clone().add(4, 'days')};
            }
        };

        const EVENT_CONFIG = {
            sample: {
                title: "Sample timeline",
                color: sampleTimelineColor,
                mode: "range",
                ...twoWeeksOutRange,
                assignDeadlines: ({start, end}) => {
                    $("#deal_sample_min_deadline").val(start).trigger("change");
                    $("#deal_sample_max_deadline").val(end).trigger("change");
                    $("#show-sample-timeline").show();
                    $("#add-sample-timeline-btn").hide();
                }
            },
            pricing: {
                title: "Pricing timeline",
                color: pricingTimelineColor,
                mode: "range",
                assignDeadlines: ({start, end}) => {
                    $("#deal_pricing_min_deadline").val(start).trigger("change");
                    $("#deal_pricing_max_deadline").val(end).trigger("change");
                    $("#show-pricing-timeline").show();
                    $("#add-pricing-timeline-btn").hide();
                }
            },
            rfi: {
                title: "RFI timeline",
                color: rfiTimelineColor,
                mode: "range",
                assignDeadlines: ({start, end}) => {
                    $("#deal_rfi_min_deadline").val(start).trigger("change");
                    $("#deal_rfi_max_deadline").val(end).trigger("change");
                    $("#show-rfi-timeline").show();
                    $("#add-rfi-timeline-btn").hide();
                }
            },
            request_deadline: {
                title: "Request deadline",
                color: requestDeadlineColor,
                mode: "single",
                assignDeadlines: ({start}) => {
                    $("#deal_stage_deadline").val(start).trigger("change");
                    $("#show-request-deadline").show();
                    $("#add-request-deadline-btn").hide();
                }
            },
            product_launch: {
                title: "Product launch timeline",
                color: productLaunchTimelineColor,
                mode: "range",
                ...twoWeeksOutRange,
                assignDeadlines: ({start, end}) => {
                    $("#deal_launch_min_deadline").val(start).trigger("change");
                    $("#deal_launch_max_deadline").val(end).trigger("change");
                    $("#show-product-launch-timeline").show();
                    $("#add-product-launch-timeline-btn").hide();
                }
            }
        };

        const config = EVENT_CONFIG[eventType];
        if (!config) return;

        title.text(config.title);
        setDatepickerColor(config.color);
        setDatePickerMode(config.mode);

        startDateInput.off("change").on("change", function () {
            validateCreateEventDates(config.mode);
        });
        endDateInput.off("change").on("change", function () {
            validateCreateEventDates(config.mode);
        });

        createButton.off("click").on("click", function () {
            if (!validateCreateEventDates(config.mode)) return;

            const {start, end} = readDateRange(config.mode);
            const calendarEvent = {
                title: config.title,
                start: start,
                end: end,
                color: config.color,
                mode: config.mode,
                type: eventType,
            };

            Deal.calendar.addEventsData([calendarEvent]);

            config.assignDeadlines({
                start: moment(start).format('YYYY-MM-DD HH:mm:ss') + ' UTC',
                end: moment(end).format('YYYY-MM-DD HH:mm:ss') + ' UTC'
            });
            Deal.destroyPopperInstance();
        });

        Deal.popperInstance = createPopper(element, document.getElementById("create-event-card"), {
            placement: "left",
            modifiers: [
                {name: "offset", options: {offset: [0, 8]}},
                {name: "preventOverflow", options: {boundary: "viewport"}},
                {name: "flip", options: {behavior: ["right", "bottom", "top"]}}
            ]
        });

        minAllowedDate = config.minDate ? config.minDate() : null;
        const minAttr = (minAllowedDate || moment()).format("YYYY-MM-DD");
        startDateInput.attr("min", minAttr);
        endDateInput.attr("min", minAttr);

        const defaults = config.defaultRange ? config.defaultRange() : {start: moment(), end: moment()};
        startDateInput.val(defaults.start.format("YYYY-MM-DD"));
        endDateInput.val(defaults.end.format("YYYY-MM-DD"));

        validateCreateEventDates(config.mode);

        $("#create-event-card").show();
        Deal.popperInstance.update();
    },

    destroyPopperInstance() {
        $("#create-event-card").hide();
        $("#event-details-card").hide();
        if (Deal.popperInstance) {
            Deal.popperInstance.destroy();
            Deal.popperInstance = null;
        }
    }
};
